export default __webpack_public_path__ + "8877f8a3275c85f8af13fe33de7c3c68.png";